import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, PayrollPeriod, PayrollPeriodUpdate } from 'types';
import { client } from 'utils/api-client';

export default function useUpdatePayrollPeriod(): UseMutationResult<
  AxiosResponse<PayrollPeriod>,
  AxiosError<ErrorMessage>,
  PayrollPeriodUpdate
> {
  const queryClient = useQueryClient();

  const updatePayrollPeriod = (payload: PayrollPeriodUpdate): Promise<AxiosResponse<PayrollPeriod>> => {
    return client.put(`payroll-periods/${payload.payrollPeriodId}/`, payload);
  };

  return useMutation(updatePayrollPeriod, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['payrollPeriods'],
      });
      queryClient.invalidateQueries({
        queryKey: ['payrollEvents'],
      });
      queryClient.invalidateQueries({
        queryKey: ['staffsPayout'],
      });
      queryClient.invalidateQueries({
        queryKey: ['payroll'],
      });
    },
  });
}
